export default "/fonts/vendor/summernote/dist/summernote.ttf?eb23b6b73e73ebe05c8442e231638815";